import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/inventory-volumes/profile/loading';

export const Route = createFileRoute('/_private/settings/inventory-volumes/$id')({
  pendingComponent: Loading,
});
